<template>
<div>
	<v-dialog
			v-model="dialog"
			persistent
			width="1000"
	>
		<v-card>
			<v-card-title
					class="headline light-blue darken-1 white--text"
					primary-title
			>
				{{$t('address.address')}}
			</v-card-title>
			<v-card-text>
				<v-container grid-list-lg>
					<v-layout row>
						<v-flex sm6 md4>
							<v-select
								:items="citizenship"
								:label="$t('address.country')"
								v-model="addressData.country"
								item-text="name"
								item-value="code"
							/>
						</v-flex>
						<v-flex sm6 md4>
							<v-text-field :label="$t('address.district')"
								v-model="addressData.district"
							/>
						</v-flex>
						<v-flex sm6 md4>
							<v-text-field :label="$t('address.region')"
								v-model="addressData.region"
							/>
						</v-flex>
					</v-layout>

					<v-layout>
						<v-flex sm6 md4>
							<v-text-field :label="$t('address.city')"
								v-model="addressData.city"
							/>
						</v-flex>
						<v-flex sm6 md4>
							<v-text-field :label="$t('address.street')"
								v-model="addressData.street"
							/>
						</v-flex>
						<v-flex sm6 md4>
							<v-text-field :label="$t('address.building_number')"
								v-model="addressData.building_number"
							/>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex sm6 md6>
							<v-text-field :label="$t('address.smirovaci')"
								v-model="addressData.smirovaci"
							/>
						</v-flex>
						<v-flex sm6 md6>
							<v-text-field :label="$t('address.index')"
								v-model="addressData.index"
							/>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
						color="red light-1"
						flat
						@click="cancel"
				>
					{{$t('common.cancel')}}
				</v-btn>
				<v-btn
						color="green light-1"
						flat
						@click="save"
				>
					{{$t('common.save')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-tooltip top slot="activator" v-if="!onlyMain">
		<v-btn
				slot="activator"
				@click="open"
				color="red lighten-1"
				small
				dark
				fab
		>
			<v-icon>add</v-icon>
		</v-btn>
		<span>{{$t('address.add_address')}}</span>
	</v-tooltip>
</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
	props: {
		dialog: Boolean,
		addressData: {
			street: String,
			building_number: String,
			smirovaci: String,
			index: String,
			city: String,
			region: String,
			district: String,
			country: String
		},
		onlyMain: Boolean
	},

	methods: {
		save() {
			this.$emit('save', this.addressData)
		},
		cancel() {
			this.$emit('cancel')
		},
		open() {
			this.$emit('open')
			this.dialog = true
		}
	},
	computed: {
		...mapGetters({
			citizenship: 'settings/getCitizenship'
		})
	}
}
</script>
